import { Button } from '@material-ui/core';
import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import useStyles from '../styles';
import { User } from '../../../types/items';

type Props = {
  user: User | null;
};

const ChangePlanButton = ({ user }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canUpgrade = user?.ref.active_subscription?.can_upgrade || false;

  const changePlanHandler = useCallback(() => {
    dispatch(push('/dashboard/plans/pricing'));
  }, [dispatch]);

  return (
    <>
      {canUpgrade
      && (
        <Button
          tabIndex={-1}
          onClick={changePlanHandler}
          className={classes.button}
          variant="outlined"
        >
        Change Plan
        </Button>
      )}
    </>
  );
};

export default ChangePlanButton;
